// extracted by mini-css-extract-plugin
export default {"header":"swZSe","headerRightSide":"_35bTm","moreButton":"_2WIMT"};